var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG300A10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 520,
    width: 520,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "-500 -500 1020 1020",
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .number {\n        font-size:30px;\n        font-family:sans-serif;\n        }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "G300A10",
    transform: "scale(1.0, -1.0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 500,
    ry: 500,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 1,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 450,
    ry: 450,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 1,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 400,
    ry: 400,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 1,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 350,
    ry: 350,
    stroke: "black",
    strokeOpacity: 1,
    strokeWidth: 1,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 300,
    ry: 300,
    stroke: "white",
    strokeOpacity: 1,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 250,
    ry: 250,
    stroke: "white",
    strokeOpacity: 1,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 200,
    ry: 200,
    stroke: "white",
    strokeOpacity: 1,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 150,
    ry: 150,
    stroke: "white",
    strokeOpacity: 1,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 100,
    ry: 100,
    stroke: "white",
    strokeOpacity: 1,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 50,
    ry: 50,
    stroke: "white",
    strokeOpacity: 1,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 25,
    ry: 25,
    stroke: "white",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeDasharray: " 30, 10"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 1,
    ry: 1,
    stroke: "white",
    strokeOpacity: 1,
    strokeWidth: 0.15,
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG300A10);
export default __webpack_public_path__ + "static/media/G300A10.fce0d3bdcd0486107e045b4f917bb6d6.svg";
export { ForwardRef as ReactComponent };